import { NavLink } from "react-router-dom";
import { cockpitComponent } from "../../components/CockpitLayoutComponents";
import MegaMenuDropdown from "../../components/dropdown/MegaMenuDropdown";

const TopNavMenuItem = ({ text, url, content }) => {
  return content ? (
    <MegaMenuDropdown id={text} label={text}>
      {content.map(cockpitComponent)}
    </MegaMenuDropdown>
  ) : (
    <NavLink id={text + "-link"} key={text} to={url}>
      {text}
    </NavLink>
  );
};

export default TopNavMenuItem;
